import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class InitiativesTableTeamEffortComponent extends Component {
  @service store;

  get teamEffort() {
    const initiative = this.args.initiative;
    if (this.args.team_id) {
      const team_id = this.args.team_id;
      const team = this.store.peekRecord('team', team_id);
      const team_pw = initiative.person_weeks_for_team(team_id, initiative);
      return [{ id: team_id, name: team?.name ?? 'Unknown', pw: team_pw }];
    } else {
      const efforts = initiative.teams.content.reduce((acc, item) => {
        const team_id = item.id;
        const team_pw = initiative.person_weeks_for_team(team_id, initiative);
        acc.push({ id: team_id, name: item.name, pw: team_pw });
        return acc;
      }, []);
      return efforts;
    }
  }
}
